import React from 'react';
import { ThemeProvider } from '@mui/material';
import theme from '../../theme/materialTheme';

const MaterialTheme = ({ children }) => {
  return <ThemeProvider {...{ theme }}>{children}</ThemeProvider>;
};

export default MaterialTheme;
